<template>
    <div class="resume-birth-scroll">
        <Select
            :selected-index="selectedIndex"
            :show="true"
            :data-list="scope"
            @on-scrollend="handleScrollEnd"
        />
    </div>
</template>

<script>
import Select from '@/components/Select';

export default {
    components: {Select},
    props: {
        scope: {
            type: Array,
            default: () => []
        },
        value: {
            type: Number,
            default: 0
        }
    },
    data() {

        return {selectedIndex: 0};
    },
    computed: {
        currentValue: {
            set(v) {
                this.$emit('input', v);
            },
            get() {
                return this.value;
            }
        }
    },
    watch: {
        currentValue: {
            handler(v, ov) {
                this.selectedIndex = Math.max(this.scope.findIndex((e) => e.value === v), 0);
            },
            immediate: true
        }
    },
    methods: {
        handleScrollEnd(item, index) {
            this.currentValue = item.value;
        }
    }
};
</script>
